import { Link } from 'react-router-dom';
import {  styled } from '@mui/material/styles';
import { Button, Card, CardContent, CardMedia, Grid, Typography } from '@mui/material';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { gridSpacing } from 'store/constant';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';

import ErrorImage from 'assets/images/error.svg'
import { FormattedMessage } from 'react-intl';

const CardMediaWrapper = styled('div')({
    maxWidth: 500,
    margin: '0 auto',
    position: 'relative'
});

const ErrorCard = styled(Card)({
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

// ==============================|| ERROR PAGE ||============================== //

const UnknownError = () => {
    const handleRefresh = () => {
        window.location.reload();
    }

    return (
        <ErrorCard>
            <CardContent>
                <Grid container justifyContent="center" spacing={gridSpacing} textAlign={"center"}>
                    <Grid item xs={6} textAlign={"center"}>
                        <CardMediaWrapper >
                            <CardMedia
                                component="img"
                                image={ErrorImage}
                                title="Erreur"
                            />
                        </CardMediaWrapper>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h1" component="div">
                            <FormattedMessage id="errors.Exceptions::default" />
                        </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <AnimateButton>
                            <Button variant="contained" size="large" onClick={handleRefresh}>
                                <HomeTwoToneIcon sx={{ fontSize: '1.3rem', mr: 0.75 }} /> <FormattedMessage id="errors.actions.refresh" />
                            </Button>
                        </AnimateButton>
                    </Grid>
                    <Grid item xs={6} textAlign={"left"}>
                        <AnimateButton>
                            <Button variant="contained" size="large" component={Link} to={'/'}>
                                <HomeTwoToneIcon sx={{ fontSize: '1.3rem', mr: 0.75 }} /> <FormattedMessage id="errors.actions.go_home" />
                            </Button>
                        </AnimateButton>
                    </Grid>
                </Grid>
            </CardContent>
        </ErrorCard>
    );
};

export default UnknownError;
